import ExpireIocn from "../../images/Expire-Icon.svg";
import "../../css/expireModal.scss";

const ExpireTemplate = (props) => {
  const { closeExpireTemplateModal, expireTemplateData, expireProceedHandler, templateTypes } =
    props;

  return (
    <div className="expire-template">
      <div className="d-flex align-center">
        <img src={ExpireIocn} alt="" width={15} />
        <h2 className="expire-template-header">Expire {templateTypes === 1 ? "Template" : "e-Detail"}</h2>
      </div>
      <div>
        {templateTypes === 1 ? <h2 className="expire-template-count">
          No. of e-Detail Created :
          {expireTemplateData ? expireTemplateData?.e_detail?.count === 0
            ? " -"
            : expireTemplateData?.e_detail?.count < 9
            ? ` 0${expireTemplateData?.e_detail?.count}`
            : ` ${expireTemplateData?.e_detail?.count}`
          : ""}
        </h2> : ""}
        <h2 className="expire-template-texts">
          <span className="expire-template-prevent">
            Expiring the {`${templateTypes === 1 ? 'template' : 'e-Detail'}`} will prevent all users from using it.
          </span>
          <span className="expire-template-text">
            {" "}
            Are you sure?{" "}
          </span>
        </h2>
      </div>
      <div className="d-flex expire-buttons">
        <button
          className="btn btn-default  expire-cancel-button"
          onClick={() => closeExpireTemplateModal()}
        >
          CANCEL
        </button>
        <button
          className="btn btn-default  expire-proceed-button"
          onClick={() => expireProceedHandler()}
        >
          PROCEED
        </button>
      </div>
    </div>
  );
};

export default ExpireTemplate;
